import { FETCHING, FETCHED } from './constants'

const initialState = {}

// sample state:
// {
//     fetching: false,
//     creatives: [{id: '', link: '', src: ''}],
// }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Let the state now that we are currently fetching
        case FETCHING: {
            return {
                ...state,
                fetching: true,
            }
        }

        // Update the state with new creatives
        case FETCHED: {
            return {
                fetching: false,
                creatives: action.payload,
            }
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Creatives/data/reducer.js